var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcPublish = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "wertyx9")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "wertyx1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "wertyx2",
    x: 0,
    y: 0,
    width: 1220,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,3 L3.75,4.5 L14.25,4.5 L14.25,3 L3.75,3 L3.75,3 Z M3.75,10.5 L6.75,10.5 L6.75,15 L11.25,15 L11.25,10.5 L14.25,10.5 L9,5.25 L3.75,10.5 L3.75,10.5 Z",
    id: "wertyx4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "wertyx3",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wertyx5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wertyx6",
    transform: "translate(-575.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "wertyx13",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wertyx14"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#wertyx1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#wertyx1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "head-row-checked",
    transform: "translate(30.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wertyx14"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#wertyx2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F8FA",
    xlinkHref: "#wertyx2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wertyx7",
    transform: "translate(413.000000, 10.000000)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "wertyx8",
    transform: "translate(49.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wertyx9",
    transform: "translate(9.000000, 9.000000) scale(1, -1) translate(-9.000000, -9.000000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wertyx12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wertyx4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wertyx11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wertyx8",
    mask: "url(#wertyx12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "wertyx10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wertyx3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "wertyx15",
    fill: "#000000",
    xlinkHref: "#wertyx3"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPublish, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-publish.77a65f22.svg";
export { ForwardRef as ReactComponent };